import React, { useState, useEffect } from "react";
// @ts-ignore
import Carousel from 'react-grid-carousel'
import { NavLink } from "react-router-dom";
import Marquee from "react-fast-marquee";
import { motion } from "framer-motion";
import Navbar from "../../Navbar";
import image from "../../../img/img1.jpeg";
import hands from "../../img/hands.png";
import volunteer from "../../img/volunteer.png";
import homemobile from "../../img/home-bg-mobile.svg";
import testbg from "../../img/test-bg.svg";
import bgbottom from "../../img/bottom.svg";
import Faq from "../../Faq";
import WFooter from "../../WFooter";
import Footer from "../../Footer";
import { SvgElement, icontypesEnum } from "../../assets/svgElement";


function AboutDetails() {

  const [open, setOpen] = useState(1);
  const [toggleText, setToggleText] = useState(1);

  const [openTestTab, setOpenTestTab] = useState(1);
  const [curImg, setCurImg] = useState(0);




  const handleOpen = (value: any) => {
    setOpen(open === value ? 0 : value);
  };

  const nextBtn = () => {
    var slider = document.getElementById("slider");

    slider!.scrollLeft = slider!.scrollLeft + 500;
  }
  const prevBtn = () => {
    var slider = document.getElementById("slider");


    slider!.scrollLeft = slider!.scrollLeft - 500;
  }



  return (
    <>
      <Navbar />
      {/* <!-- Start block --> */}
      <section className="bg-[#FBFBFB] body-font font-poppins md:pt-20 pt-[92px]">
        <div className="">
          <div
            style={{
              backgroundImage: `url(${image})`,
              backgroundRepeat: "no-repeat",
              backgroundSize: "cover",
              backgroundPosition: 'center center'

            }}
            className="md:pt-52 md:pb-8  flex justify-start "
          >
            <div className="py-20">
              <div className="text-[white] max-w-fit md:ml-44 pl-2 pr-20 flex justify-start mb-4 bg-black bg-opacity-80">
                <span className="font-[700] md:text-[20px] text-[20px] py-4" > Project Details</span>
              </div>

              <div className="text-[white] md:ml-44 pl-2 pr-20 flex justify-start bg-[#9F0000BA] bg-opacity-80">
                <span className="font-[700] md:text-[48px] text-[20px] py-4" > Alimosho Stakeholders Sensitization Meeting</span>
              </div>
            </div>
          </div>

          {/* <div className="bg-black py-4">
            <div className="grid md:grid-cols-2 md:px-20 px-3 gap-10 pt-10">
              <div className="text-white">
                Location : Pako Field, Pako B/Stp, Dopemu Lagos.
              </div>

              <div className="text-white">
                Topic : Talent Hunt
              </div>

              <div className="text-white">
                Objective : The center also work with young people to harness their talents and potentials in sports particularly football.
              </div>
            </div>
          </div> */}
        </div>
      </section>


      <section>
        <div className="pt-10 md:px-20 px-4 pb-5">
          <div className="text-[white] max-w-fit pl-2 pr-20 flex justify-start mb-10 bg-[#FA0000] ">
            <span className="font-[700] md:text-[20px] text-[20px] py-2" > Project Overview</span>
          </div>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">As part of our effort to scale up our impactful projects, stakeholders from Lagos, Ogun, and Ondo States came together to review past projects, identify challenges, and proffered the way forward for 2026. The meeting was conceived as a strategic platform to better meet the needs of the communities we serve.
          </p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5"> Following this, key leaders from Alimosho Local Government convened at the Youth Care Project office to deliberate on the next steps and provide a supportive environment, offering their full political commitment. This strategic engagement represents a major breakthrough for Youth Care Project.</p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">During the meeting, we explored innovative and strategic approaches to build effective partnerships and ensure successful project execution. We examined mobilization strategies, operational frameworks, and strengthening the institutional structures required to sustain the proposed project activities within the communities.</p>

          <p className="text-[#666666] text-[17px] font-[300] pb-5">This milestone reinforces our shared commitment to a future where service to humanity is deeply valued and its impact resonates with every beneficiary. We are grateful for the dedication, insights, and partnership of our stakeholders. Progress happens when institutions, communities, and vision align. Together, we are strengthening health systems, building healthier communities, and empowering young people for lasting impact.</p>



        </div>
        <div className="grid md:grid-cols-4 py-10 gap-2 px-10">
          <span>  <img src="/images/alimoshoStakeholderSensitization/img1.jpeg" alt="location" style={{}} /></span>
          <span>  <img src="/images/alimoshoStakeholderSensitization/img2.jpeg" alt="location" style={{}} /></span>
          <span>  <img src="/images/alimoshoStakeholderSensitization/img3.jpeg" alt="location" style={{}} /></span>
          <span>  <img src="/images/alimoshoStakeholderSensitization/img4.jpeg" alt="location" style={{}} /></span>

        </div>
      </section>

      <Footer />


      {/* <!-- End block --> */}

    </>
  );
}

export default AboutDetails;
